import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { totalRentConcept, totalCompleteRent } from '../../helpers/productsPrice.js';

export const CertificationRentTable = ({ rents }) => {

    const { rents: dataRents } = rents;
    const rentsToObj = JSON.parse(dataRents)

    return (
        <TableContainer component='div' >
            <Table sx={{ minWidth: 650 }} size='small' aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align='left'>Concepto</TableCell>
                        <TableCell align="center">Unidad</TableCell>
                        <TableCell align="center">Cantidad</TableCell>
                        <TableCell align='center'>Días</TableCell>
                        <TableCell align='center'>Precio/día x ud</TableCell>
                        <TableCell align="right">Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rentsToObj.map(fields => (
                        <TableRow key={fields.id}>
                            <TableCell align='left'>{fields.concept}</TableCell>
                            <TableCell align="center">{fields.measure}</TableCell>
                            <TableCell align="center">{fields.size}</TableCell>
                            <TableCell align='center'>{fields.rentsDays}</TableCell>
                            <TableCell align='center'>{parseFloat(fields.price).toFixed(3).toString().replace(/\./g,',')}€</TableCell>
                            <TableCell align="right">{totalRentConcept(fields.rentsDays, fields.price, fields.size).toFixed(2)}€</TableCell>
                        </TableRow>
                    ))}
                    <TableRow>
                        <TableCell align="left"></TableCell>
                        <TableCell align='center'></TableCell>
                        <TableCell align='center'></TableCell>
                        <TableCell align='center'></TableCell>
                        <TableCell align='center'><b>Suma:</b> </TableCell>
                        <TableCell align="right" sx={{ backgroundColor: '#D2D2D2' }}><b>{totalCompleteRent(rentsToObj).toFixed(2)}€</b></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}